
export class User {
    uid: string
    firstname: string
    lastname: string
    description: string
    email: string
    images: string[]
    credits: number

    private readonly malePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/10354686_10150004552801856_220367501106153455_n.jpg'
    private readonly femalePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/1379841_10150004552801901_469209496895221757_n.jpg'

    getPrimaryPicture() {
      const image = this.images[0]

      if (image.includes(this.malePictureUrl)) {
        return '../../../assets/img/users/default_male.png'
      }

      if (image.includes(this.femalePictureUrl)) {
        return '../../../assets/img/users/default_female.png'
      }

      return image
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/user.model.ts